import styled from 'styled-components'

import { MOBILE_WIDTH } from '@constants/sizes'

import COLORS from '@colors'

export const Pane = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 4;
`

export const ModalWrapper = styled.div`
  width: calc(100% - 64px);
  padding: 16px;
  background-color: ${COLORS.white};
  max-height: 90vh;
  min-width: 20%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);

  @media (min-width: ${MOBILE_WIDTH}px) {
    width: ${props => (props.width ? props.width : 'auto')};
  }
`

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`
export const ModalBody = styled.div`
  max-height: calc(87vh - 24px);
  overflow-y: auto;
  padding-top: 16px;
`

export const Close = styled.button`
  border: 0;
  background-color: transparent;
  cursor: pointer;
  height: 24px;
  outline: 0;
  user-select: none;

  &:hover {
    background-color: ${COLORS.grayE};
  }
`
